
import { defineComponent, onMounted, ref } from "vue";
import { useStore } from "vuex";
import ApiService from "@/core/services/ApiService";

export default defineComponent({
  name: "kt-widget-6",
  props: {
    widgetClasses: String,
    color: String,
    description: String,
    progress: String,
    title: String,
    amount: String,
    count: String,
  },
  components: {},
  setup() {
    const store = useStore();
    const actionCount = ref("0");
    const uploadCount = ref("0");
    const eventCount = ref("0");
    onMounted(() => {
      setTimeout(async () => {
        try {
          const { data } = await ApiService.get(
            `dashboard/group.activities?group_id=${store.getters.currentUser.data.companygroupid}`
          );
          actionCount.value = data.data[0].action_count;
          uploadCount.value = data.data[0].uploads_count;
          eventCount.value = data.data[0].event_count;
        } catch (e) {
          actionCount.value = "0";
          uploadCount.value = "0";
          eventCount.value = "0";
        }
      }, 1200);
    });
    return {
      actionCount,
      uploadCount,
      eventCount,
    };
  },
});
